<template>
  <b-card no-body class="card mb-0 mt-0 p-3">
    <div class="form-group bmd-form-group">
      <b-form-checkbox v-model="condensed_analytical_commission_by_profile_report">
          Relatório de Comissão Analítica por Perfil Resumido
      </b-form-checkbox>
    </div>
    <div class="form-group bmd-form-group">
      <b-form-checkbox v-model="display_supervisor_summary_on_analytical_commission_by_profile_report">
          Mostrar Resumos por Supervisor no Relatório de Comissão Analítica por Perfil Resumido
      </b-form-checkbox>
    </div>
    <div class="form-group bmd-form-group">
      <b-form-checkbox v-model="display_commissions_totals_only_on_analytical_commission_by_profile_report">
          Somar as comissões de todas as administradoras no relatório de Comissão Analítica por Perfil
      </b-form-checkbox>
    </div>
    <div class="form-group bmd-form-group">
      <b-form-checkbox v-model="analytical_commission_by_profile_report_alternate_layout">
          Utilizar layout alternativo no relatório de Comissão Analítica por Perfil
      </b-form-checkbox>
    </div>
    <div class="form-group bmd-form-group">
      <b-form-checkbox v-model="print_empty_sales_on_analytical_commission_by_profile_report">
          Imprimir vendas em branco no relatório de Comissão Analítica por Perfil
      </b-form-checkbox>
    </div>
  </b-card>
</template>

<script>
export default {
  computed: {
    condensed_analytical_commission_by_profile_report: {
      get: function () {
        return Boolean(this.$store.state.configurations.model.condensed_analytical_commission_by_profile_report);
      },
      set: function (value) {
        this.$store.state.configurations.model.condensed_analytical_commission_by_profile_report = value;
      }
    },
    display_supervisor_summary_on_analytical_commission_by_profile_report: {
      get: function () {
        return Boolean(this.$store.state.configurations.model.display_supervisor_summary_on_analytical_commission_by_profile_report);
      },
      set: function (value) {
        this.$store.state.configurations.model.display_supervisor_summary_on_analytical_commission_by_profile_report = value;
      }
    },
    display_commissions_totals_only_on_analytical_commission_by_profile_report: {
      get: function () {
        return Boolean(this.$store.state.configurations.model.display_commissions_totals_only_on_analytical_commission_by_profile_report);
      },
      set: function (value) {
        this.$store.state.configurations.model.display_commissions_totals_only_on_analytical_commission_by_profile_report = value;
      }
    },
    analytical_commission_by_profile_report_alternate_layout: {
      get: function () {
        return Boolean(this.$store.state.configurations.model.analytical_commission_by_profile_report_alternate_layout);
      },
      set: function (value) {
        this.$store.state.configurations.model.analytical_commission_by_profile_report_alternate_layout = value;
      }
    },
    print_empty_sales_on_analytical_commission_by_profile_report: {
      get: function () {
        return Boolean(this.$store.state.configurations.model.print_empty_sales_on_analytical_commission_by_profile_report);
      },
      set: function (value) {
        this.$store.state.configurations.model.print_empty_sales_on_analytical_commission_by_profile_report = value;
      }
    }
  },
};
</script>
